let apiUrl;
let webUrl;
let environment;
let cuUrl = 'https://www.claveunica.gob.cl';

const hostname = window && window.location && window.location.hostname;

if(hostname === 'pagos.estugira.com') {
    apiUrl = 'https://estugira.com/estugiraapiv2';
    webUrl = 'https://pagos.estugira.com';
    environment = 'PRODUCTION';
}else if(hostname === 'testpagos.estugira.com') {
    apiUrl = 'https://estugira.com/estugiraapiv2';
    webUrl = 'https://testpagos.estugira.com';
    environment = 'TEST';
}
else {
    apiUrl = 'http://estugira-local.lazos.cl:3002';
    webUrl = 'http://estugira-local.lazos.cl:3000';
    environment = 'DEVELOPMENT';
}




export const APP_CONFIG = { apiUrl, webUrl, environment, cuUrl };
